import {setConnectionStatus} from "../../../reducers/configSlice";
import {SOCKET_CONNECTED} from "../../../constants/default";
import {dispatchAction} from "../../state/dispatchAction";
import {hideToast} from "../../toastMessage";

export const handleConnect = (reason) => {
    hideToast();
    dispatchAction(setConnectionStatus(SOCKET_CONNECTED));
};